<template>
  <div><!-- this is inserted into ClaimForms.vue-->
    <div class="c-card--claim-forms__body">
      <transition name="fade-and-slide">
        <div
          v-if  = "submittedForm !== null"
          ref   = "toast"
          class = "c-toast t-toast-success"
        >
          <p class="c-toast__text">
            {{
              (forms[submittedForm] && forms[submittedForm].submitMessage) ||
              $t('web.form_list.success_message')
            }}
          </p>
        </div>
      </transition>

      <div class="c-card--claim-forms__form-list qa-form-list">
        <!--
            Using `button`s breaks `justify-content: space-between` on
            macOS Sierra Safari v10.1.
        -->
        <div
          v-for  = "(form, formIndex) in forms"
          @click = "openForm(formIndex)"
          class  = "c-card--claim-forms__form-list__button qa-select-form-button"
        >
          <span>{{ form.name }}</span>
          <i class="fa fa-arrow-right t-headline"></i>
        </div>
      </div>
    </div>
  </div>
</template>




<script>
  export default {
    props: ['forms', 'submittedForm'],
    methods: {
      openForm (formIndex) {
        this.$parent.$emit('open-form', formIndex)
      }
    }
  }
</script>


<style lang="sass" scoped>
  .fade-and-slide-leave-active
    max-height: 80px
    transition: opacity 1s, max-height 1s

  .fade-and-slide-leave-to
    max-height: 0
    opacity: 0
</style>



// WEBPACK FOOTER //
// FormList.vue?2f5e822c